import { styled } from '@staffino/primitive-controls';

const Form = styled.form({
  height: '100%',
});

export default Form;
